import { getFeatureEnabled, isDesktopQuery } from '@gig/magic-common';
import { Feature, GAMES_RECOMMENDED_GAMES_USER, USER_LOGGED_IN_UPDATED } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { DeviceType } from '@gig/magic-sdk/dist/adapter/games/getRecommendedGames';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class UserRecommendedGamesService {
  constructor() {
    getFeatureEnabled(Feature.RECOMMENDED_GAMES_USER).then((enabled) => {
      if (enabled) {
        this.subscribeToUserLoggedInChanges();
      } else {
        window.eventBus.publish(GAMES_RECOMMENDED_GAMES_USER, []);
      }
    });
  }
  subscribeToUserLoggedInChanges() {
    window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, (event) => __async(this, null, function* () {
      const isDesktop = yield isDesktopQuery();
      const deviceType = isDesktop ? DeviceType.DESKTOP : DeviceType.MOBILE;
      if (event.payload) {
        const payload = yield magic.methods.games.getRecommendedGames({
          deviceType
        });
        window.eventBus.publish(GAMES_RECOMMENDED_GAMES_USER, payload);
      } else {
        window.eventBus.publish(GAMES_RECOMMENDED_GAMES_USER, []);
      }
    }), { replay: true });
  }
}

export { UserRecommendedGamesService };
